"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchOrgService = void 0;
var tslib_1 = require("tslib");
var _1 = require(".");
var SearchOrgService = /** @class */ (function () {
    function SearchOrgService() {
        this.__priority = 50;
        this.query = { text: 'test' };
    }
    SearchOrgService.prototype.sendQuery = function (str) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.query.text = str;
                        rest = _1.Services.Department.rest;
                        return [4 /*yield*/, rest.action('org.search', this.query)];
                    case 1: return [2 /*return*/, ((_a.sent()).results)];
                }
            });
        });
    };
    return SearchOrgService;
}());
exports.SearchOrgService = SearchOrgService;
//# sourceMappingURL=search.org.service.js.map